(function (w) {
	'use strict';
	const app = angular.module('mx.components');

	app.directive('mxNumericEdit', function mxNumericEditDirective() {
		const directive = new mx.components.FormControlBase(MxNumericEditCtrl, 'mx-numeric-edit/mx-numeric-edit.html');
		angular.extend(directive.bindToController, {
			format: '@',
			disableFormatting: '@',
			mxMin: '<?',
			mxMax: '<?',
			onBlur: '<',
			scale: '@',
			inputDebounce: '@',
		});

		return directive;
	});

	MxNumericEditCtrl.$inject = ['$timeout', '$scope', '$element'];

	function MxNumericEditCtrl($timeout, $scope, $element) {
		const vm = this;

		vm.$onInit = function () {
			mx.components.FormControlControllerBase.call(vm, $timeout);
			if (typeof vm.onBlur === 'function') {
				var input = $element.find('input');
				if (input) {
					input.on('blur', function () {
						vm.onBlur();
					});
					input.focus();
				}
			}
			vm.format = vm.format || mxNumericEditFormat.Integer;
		};

		vm.$postLink = function () {
			vm.setHintHandlers($element.find('input'));

			var model = $scope.vm.ngModel;
			if (model === null) {
				return;
			}

			valueRangeValidator($scope, model.$$attr, model, false);
			valueRangeValidator($scope, model.$$attr, model, true);
		};

		var validateParsers = function () {
			var model = $scope.vm.ngModel;
			if (model === null) {
				return;
			}
			angular.forEach(model.$parsers, function (parser) {
				parser(model.$modelValue);
			});
		};

		$scope.$watch('vm.disabled', validateParsers);
		$scope.$watch('vm.readOnly', validateParsers);

		return vm;
	}

	function valueRangeValidator(scope, attr, ctrl, isMax) {
		var name = isMax ? 'mxMax' : 'mxMin';

		var validator = function (value) {
			var customValue = scope.$eval(attr[name]);
			var borderValue = getBorderValue(attr.format, isMax);

			var borderVal = !isNaN(customValue) ? customValue : borderValue || 0;
			if (!isNaN(parseInt(value)) && ((isMax && value > borderVal) || (!isMax && value < borderVal))) {
				/* control is valid if it's disabled or readonly */
				ctrl.$error = {};
				scope.vm.setValidity(name, scope.vm.disabled === true || scope.vm.readOnly === true);
			} else {
				scope.vm.setValidity(name, true);
				return value;
			}
		};

		ctrl.$parsers.push(validator);
		ctrl.$formatters.push(validator);
	}

	function getBorderValue(format, isMax) {
		switch (format) {
			case 'float':
			case mxNumericEditFormat.Float:
				return isMax ? 3.40282347e38 : -3.40282347e38;

			case mxNumericEditFormat.Long:
				return isMax ? 9223372036854776000 : -9223372036854775808;

			case mxNumericEditFormat.Decimal:
				return isMax ? 79228162514264340000000000000 : -792281625142643400000000000000;

			case 'integer':
			case mxNumericEditFormat.Integer:
				return isMax ? 2147483647 : -2147483648;
			default:
				return isMax ? 2147483647 : -2147483648;
		}
	}

	var mxNumericEditFormat = {
		Integer: 'IntType',
		Float: 'FloatType',
		Long: 'LongType',
		Decimal: 'DecimalType',
	};

	w.mx = w.mx || {};
	w.mx.components = w.mx.components || {};
	w.mx.components.Forms = w.mx.components.Forms || {};
	w.mx.components.Forms.NumericEditFormat = mxNumericEditFormat;
})(window);
